// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#TVChartContainer {
	/* background-color: #0c0917 !important; */
	height: 100%;
	width: 100%;
}

#TVChartContainer>* {
	width: 100%;
}

/* .mobile-spot-container{
	background-color: #fff !important;
} */


.mobile-spot-container-light #TVChartContainer {
	background-color: #fff !important;
}

.mobile-spot-container-dark #TVChartContainer {
	background-color: #000 !important;}

.trade-wrapper-mobile {
	padding: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/customComponents/Libraries/TVChartContainer/index.css"],"names":[],"mappings":"AAAA;CACC,0CAA0C;CAC1C,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;;GAEG;;;AAGH;CACC,iCAAiC;AAClC;;AAEA;CACC,iCAAiC,CAAC;;AAEnC;CACC,qBAAqB;AACtB","sourcesContent":["#TVChartContainer {\n\t/* background-color: #0c0917 !important; */\n\theight: 100%;\n\twidth: 100%;\n}\n\n#TVChartContainer>* {\n\twidth: 100%;\n}\n\n/* .mobile-spot-container{\n\tbackground-color: #fff !important;\n} */\n\n\n.mobile-spot-container-light #TVChartContainer {\n\tbackground-color: #fff !important;\n}\n\n.mobile-spot-container-dark #TVChartContainer {\n\tbackground-color: #000 !important;}\n\n.trade-wrapper-mobile {\n\tpadding: 0 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
